export default ($axios, pubId) => (resource) => ({
  autocomplete(searchTerm, params = {}) {
    const terms = encodeURI(searchTerm)
    return $axios.get(`/content-api/rest/auto/autocompleteHome/${terms}/${pubId}`, {params}).then((response) => response.data)
  },
  hotel(hotelId) {
    return $axios.get(`/content-api/${pubId}/hotels/${hotelId}`).then((response) => response.data)
  },
  getComponentData(componentId) {
    return $axios
      .get(
        `/content-api/${pubId}/component/${componentId}/link?templateId=${componentId}&pageURI=tcm:0-0-0&linkAttributes=&linkText=back&textOnFail=true&addAnchor=false&subDomain=false&relativeUrl=false&queryString=`
      )
      .then((response) => response.data)
  },
  getLabels() {
    const url = `/content-api/${pubId}/allLabels`
    return $axios.get(url).then((result) => result.data)
  },
  getLabel(labelId) {
    const url = `/content-api/${pubId}/label/${labelId}`
    return $axios.get(url).then((result) => result.data)
  },
  getContentPage(pageId) {
    return $axios
      .get(
        `/content-api/${pubId}/page/${pageId}`
      )
      .then((response) => response.data)
  },
  ssoApiLoginExternalToken(env, TOKENSSO) {
    const enviroment = {
      'dev': 'http://nhdev-ecp-sso.nh-hotels.com',
      'qa': 'https://nhqa-ecp-sso.nh-hotels.com',
      'uat': 'https://nhuat-ecp-sso.nh-hotels.com',
      'prod': 'https://secure-web.nh-hotels.com',
      'preview': 'https://secure-web.nh-hotels.com'
    }

    const dom = enviroment[env]
    const url = `${dom}/sso-api/requestExternalToken`
    return $axios.get(url, {
      headers: {
        'TOKENSSO': TOKENSSO
      }
    })
  }
})
